import classNames from 'classnames'

import { TableCellEditButton, TableTextCell } from '../../Table'
import { getPagesOverlimitTooltip } from '../DocFlowUploading'

import * as styles from './DocFlowUploadingTypeCell.module.css'

function DocFlowUploadingTypeCell({
  className,
  disabled,
  isPagesOverlimit,
  mappingTypeOptions,
  value,
  onClickEditType,
  ...restProps
}) {
  return (
    <TableTextCell
      {...restProps}
      {...(isPagesOverlimit ? { tooltip: getPagesOverlimitTooltip() } : null)}
      className={classNames(styles.DocFlowUploadingTypeCell, className, {
        [styles.overlimit]: isPagesOverlimit,
      })}
      value={mappingTypeOptions[value]?.label}
    >
      {disabled || isPagesOverlimit ? null : (
        <TableCellEditButton
          className={styles.editButton}
          onClick={onClickEditType}
        />
      )}
    </TableTextCell>
  )
}

export default DocFlowUploadingTypeCell
